import type { ApiClient } from './client';

export const performanceMethods = {
async getPerformanceRecords(vehicleId: number): Promise<any[]> {
      const response = await this.makeRequest<any[]>(`/performance_list.php?vehicle_id=${vehicleId}`);
      return response.data || [];
    },


    async createPerformanceRecord(recordData: any): Promise<any> {
      const response = await this.makeRequest<any>('/performance_create.php', {
        method: 'POST',
        headers: {
          'Authorization': `Bearer ${this.getAccessToken()}`
        },
        body: JSON.stringify(this.sanitizePerformanceData(recordData))
      });

      if (response.success && response.data) {
        return response.data;
      }
      throw new Error(response.error || 'Failed to create performance record');
    },


    async updatePerformanceRecord(recordId: number, recordData: any): Promise<any> {
      try {
        if (!this.isAuthenticated()) {
          throw new Error('Authentication required');
        }

        const response = await this.makeRequest<any>(`/performance_update.php?id=${recordId}`, {
          method: 'PUT',
          headers: {
            'Authorization': `Bearer ${this.getAccessToken()}`
          },
          body: JSON.stringify(this.sanitizePerformanceData(recordData))
        });

        if (response.success && response.data) {
          return response.data;
        } else {
          throw new Error(response.error || 'Failed to update performance record');
        }
      } catch (error: any) {
        console.error('Failed to update performance record:', error);
        throw new Error(error.message || 'Failed to update performance record');
      }
    },


    async deletePerformanceRecord(recordId: number): Promise<void> {
      const response = await this.makeRequest<any>(`/performance_delete.php?id=${recordId}`, {
        method: 'DELETE',
        headers: {
          'Authorization': `Bearer ${this.getAccessToken()}`
        }
      });

      if (!response.success) {
        throw new Error(response.error || 'Failed to delete performance record');
      }
    }
} satisfies ThisType<ApiClient>;
